import { render } from "./ReportsPageTableColumnLabel.vue?vue&type=template&id=b913ffc4&ts=true"
import script from "./ReportsPageTableColumnLabel.vue?vue&type=script&lang=ts"
export * from "./ReportsPageTableColumnLabel.vue?vue&type=script&lang=ts"

import "./ReportsPageTableColumnLabel.vue?vue&type=style&index=0&id=b913ffc4&lang=stylus"

import exportComponent from "/tmp/ffsecurity-ui/packages/v2/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__